export const getPlayedGames = (games: Edge.RepeaterProfileGames, userGamesIds: Array<number>) => {
  return userGamesIds.reduce<Edge.RepeaterProfileGames>((playedGames, gameId) => {
    const playedGame = games.find((g) => gameId === parseInt(g.options.gameId, 10));

    if (playedGame) {
      playedGames.push(playedGame);
    }

    return playedGames;
  }, []);
};
